import { useReveal } from "../hooks/useReveal";
import { ArrowRight } from "lucide-react";
import { WHATSAPP_URL } from "../lib/contact";

const benefits = [
  {
    n: "01",
    title: "Estrategia, no improvisación",
    desc: "Cada post, cada anuncio y cada pieza nace de un plan medible. Nada al azar.",
  },
  {
    n: "02",
    title: "Estética premium",
    desc: "Diseño visual cuidado al detalle. Tu marca se ve como las grandes, desde el día uno.",
  },
  {
    n: "03",
    title: "Comunicación directa",
    desc: "Hablas con quien hace el trabajo. Sin intermediarios, sin reuniones eternas.",
  },
  {
    n: "04",
    title: "Resultados que se ven",
    desc: "Reportes claros y métricas reales. Sabes exactamente qué está funcionando y por qué.",
  },
];

export const Benefits = () => {
  const ref = useReveal();
  return (
    <section
      id="beneficios"
      data-testid="benefits-section"
      className="relative py-24 md:py-36"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div ref={ref} className="reveal grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-5 lg:sticky lg:top-28 self-start">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-10 h-px bg-[#ca0013]" />
              <span className="font-label text-xs text-[#ca0013]">
                Beneficios
              </span>
            </div>
            <h2
              data-testid="benefits-title"
              className="font-display text-4xl md:text-6xl tracking-tighter leading-[0.95]"
            >
              Por qué trabajar
              <br />
              con{" "}
              <span className="font-editorial text-[#ca0013] font-normal">
                nosotros
              </span>
              .
            </h2>
            <p className="font-body text-[#4a4a4a] mt-6 max-w-md leading-relaxed">
              No vendemos paquetes genéricos. Construimos relaciones a largo
              plazo con negocios que quieren tomarse su marca en serio.
            </p>
            <a
              data-testid="benefits-cta"
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary group inline-flex items-center gap-3 bg-[#111] hover:bg-[#ca0013] text-white font-bold px-7 py-4 rounded-full transition-colors font-body mt-10"
            >
              Analizamos tu negocio sin costo
              <ArrowRight size={18} className="btn-arrow" />
            </a>
          </div>

          <div className="lg:col-span-7 lg:border-l border-black/15 lg:pl-12">
            <ul className="divide-y divide-black/15 border-y border-black/15">
              {benefits.map((b, i) => (
                <li
                  key={i}
                  data-testid={`benefit-item-${b.n}`}
                  className="py-8 md:py-10 grid grid-cols-12 gap-6 items-start group hover:bg-[#eeede9] -mx-6 px-6 transition-colors"
                >
                  <div className="col-span-2 number-stroke text-5xl md:text-7xl">
                    {b.n}
                  </div>
                  <div className="col-span-10">
                    <h3 className="font-display text-2xl md:text-3xl tracking-tight leading-tight">
                      {b.title}
                    </h3>
                    <p className="font-body text-[#4a4a4a] mt-3 leading-relaxed max-w-xl">
                      {b.desc}
                    </p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};
